
import { Collapse, CollapseItem, Radio, Button } from 'element-ui';
import FreePayment from '@/services/payments/FreePayment';
import cartMixin from '@/mixins/cartMixin';
import addressMixin from '@/mixins/addressMixin';

export default {
  mixins: [cartMixin, addressMixin],
  data() {
    return {
      activeCollapse: 'free',
      loading: false,
    };
  },
  methods: {
    handleFreePayment() {
      this.loading = true;
      const freePayment = new FreePayment({
        cart: this.cart,
        auth: this.$auth,
        http: this.$http,
        addressService: this.addressService,
      });

      freePayment.createPayment().then((response) => {
        this.$router.push(
          this.localePath(
            `/cart/thanks/accepted?orderid=${response.IdOrder}&cartid=${this.cartService.idCart}`
          )
        );
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  components: {
    Collapse,
    CollapseItem,
    Radio,
    Button,
  },
};
